<template>
  <div
    id="services"
    class="container mx-auto bg-services-background shadow-xl pb-20 py-24"
  >
    <detail-odd title="Laadpalen" :is-first="true">
      Rijd je elektrisch? Dan is het voordeliger om thuis te kunnen laden,
      dan aan een publiek laadpunt. Via een gewoon stopcontact kan dat lang duren.
      Een eigen laadpaal of laadstation heeft een veel hogere capaciteit, zodat
      je snel én veilig kan opladen.
    </detail-odd>
    <detail-even title="Keuring">
      Bij de aankoop van een woning hoort er altijd een keuringsverslag te
      zitten. Deze keuring is voor de veiligheid en ook nodig voor de
      verzekering. Laat dit zeker niet liggen en maak het in orde. Vaak valt de
      kostprijs mee om alles netjes in orde te maken. Vraag vrijblijvend offerte
      op maat aan.
    </detail-even>
    <detail-odd title="Nieuwbouw">
      Plan je een huis te bouwen en heb je al zicht op wat jullie wensen, of
      willen jullie advies wat te doen met de elektriciteit in de woning? Wij
      helpen je graag vanaf de start van jullie project tot aan de afwerking van
      de elektrische installatie naar jullie wens.
    </detail-odd>
    <detail-even title="Renovatie">
      Bij renovatie is het niet altijd duidelijk waar je bij uitkomt na de start
      van een project. Vrijwel alles is mogelijk om een oudere woning om te
      bouwen naar een huis met alle moderne technologie. Bij een renovatie
      kunnen we stap voor stap te werk gaan voor een mooie uitkomst op het einde
      zodat het huis helemaal klaar is om goed in geleefd te worden.
    </detail-even>
    <detail-odd title="Zelfbouw met begeleiding"
      >Of het nu gaat om een nieuwbouw, renovatie of een kleiner project, is het
      voor de doorwinterde doe-het-zelver altijd leuk om wat kosten te besparen
      op uren. Bij ons is het mogelijk om materiaal aan te schaffen met
      begeleiding van de installatie. We leggen alles uit en geven advies zodat
      jullie zelf verder kunnen. Bij problemen zijn we natuurlijk altijd
      beschikbaar om ter plaatse te komen.
    </detail-odd>
    <detail-even title="Zonnepanelen"
      >Omwille van de hoge veiligheidseisen beperken we ons met het plaatsen van
      zonnepanelen op platte- en industrie daken. Ook tuinhuizen, carports en
      kleine garages zijn mogelijk om te voorzien van zonnepanelen. Het plaatsen
      van zonnepanelen is tot op heden zeker nog interessant voor de
      energiefactuur.
    </detail-even>
    <detail-odd title="Elektrische boilers"
      >Het vervangen van een elektrische boiler kan leiden tot een enorme
      besparing op de energiefactuur. Doordat ze vaak gemakkelijk om te wisselen
      zijn kan de plaatsing snel gaan en is de hinder van de werken eerder
      beperkt. Ook sanitair werken zijn voor ons geen probleem als er zaken
      moeten veranderen of aangepast worden.
    </detail-odd>
    <detail-even title="Elektrische schema's">
      Elke elektrische installatie moet beschikken over een schema om alles
      correct aan te duiden zodat er bij problemen snel gehandeld kan worden. Op
      deze manier zijn problemen of mogelijke probleem gemakkelijk op te sporen
      en aan te pakken. Wij maken tekeningen van start tot finish. Van het
      opmeten van de woning voor het grondplan tot de werking en de opbouw van
      de elektrische installatie.
    </detail-even>
    <detail-odd title="Tijdelijke aansluiting/werfkast">
      Om vanaf de start van een werf voorzien te zijn van stroom is er vaak een
      tijdelijke aansluiting nodig. Bij ons kan je terecht voor de huur en
      installatie van zo een werfkast om de werf. Bij de aankoop en of
      installatie van de materialen door ons komt de huurprijs te vervallen en
      valt deze kost al weg van jullie totaalproject.
    </detail-odd>
  </div>
</template>
<script>
import DetailOdd from '@/components/services/DetailOdd.vue';
import DetailEven from '@/components/services/DetailEven.vue';

export default {
  name: 'services',
  components: { DetailOdd, DetailEven },
};
</script>
